<div class="parent-class">
  <div class="child-container">
    <div class="header">
      <div class="header-content">
        <div class="game-count-column">R</div>
        <div class="game-count-column">D</div>
        <div class="game-count-column">S</div>
        <div class="card-column">1st</div>
        <div class="card-column">2nd</div>
        <div class="card-column">M</div>
      </div>
    </div>
    <div class="history-list">
      <div *ngFor="let history of gameHistoryData" class="history-item w-80 md:w-full">
        <div class="history-content">
          <div class="game-no">{{ history.dealNo }}</div>
          <div class="deal-no">{{ history.gameNo }}</div>
          <div class="seat-no">{{ history.seatNo }}</div>
          <div class="card-row">
            <app-small-card
              [number]="history.firstCard.number"
              [type]="history.firstCard.cardType"
            ></app-small-card>
          </div>
          <div class="card-row">
            <app-small-card
              [number]="history.secondCard.number"
              [type]="history.secondCard.cardType"
            ></app-small-card>
          </div>
          <div class="card-row">
            <app-small-card
              [number]="history.maverickCard.number"
              [type]="history.maverickCard.cardType"
            ></app-small-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
